import { Box, Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useEffect, useState } from "react";
import { get, isEmpty } from "lodash";
import { useNavigate } from "react-router-dom";
import { FormState, UseFormWatch } from "react-hook-form";
import { v4 as uuidv4 } from "uuid";
import dayjs from "dayjs";
import { nanoid } from 'nanoid';
import { saveAs } from "file-saver";

import {
  PatientHeaderTabs,
  ReferralGrid,
  DetailBox,
  width100PCT,
  CancelButtonGrid,
  NextButtonGrid,
  ButtonMinWidth,
  PatientHeaderTab,
  ButtonMinWidth_Outlined,
} from "../styles/style";
import { a11yProps, appendTimestampToFilename, currentDate, generateAgencyDetailsNote, getCurrnetPageFullPath, getFormattedDateTime, getLanguageLabel, getUaserPageViewPayload, getValue } from "../../../utils";
import { flexAlignCentre } from "../../../styles/mui/styles/display";
import { notVisitedTabs, TabData } from "../../../models/TabSessionStorage";
import AlertDialog from "./AlertDialog";
import ConfirmationDialog from "./ConfirmationDialog";
import ErrorDialog from "./ErrorDialog";
import {
  AuthorizationValuesForIngest,
  confirmationMessage,
  Constants,
  createDocumentReviewPayload,
  DocumentDownloadActionDispatchTypes,
  DocumentReviewActionDispatchTypes,
  getMatchingNames,
  IngestProcessActionDispatchTypes,
  Numbers,
  PostPriorAuthSubmitActionDispatchTypes,
  PriorAuthHeaderLabel,
  ReferralDocumentFileDispatchTypes,
  RequestTabCount,
  SaveDetailsAlertMessage,
  SlotsDispatchTypes,
} from "../../../constants/Referral";
import { TabSessionStorageResponse } from "../../../models/api/TabSessionStorage";
import { ApplicationRoute } from "../../../constants/ApplicationUrl";
import { CreatePatientActionDispatchTypes, EligibilityCheckActionDispatchTypes, IcdCodeActionDispatchTypes, InformationActionDispatchTypes, MemberInfoDataActionDispatchTypes, PatientFromMbiActionDispatchTypes, PatientInformationByIdActionDispatchTypes } from "../../../constants/Patient";
import OrderingPhysician from "./OrderingPhysician";
import { Discipline, ListOptions } from "../../../models/Master";
import { MyAccountModel } from "../../../models/MyAccount";
import { ServiceProvider } from "../../../models/ServiceProvider";
import { AgencyListPayload } from "../../../models/ProviderMaterials";
import AgencyDetails from "../containers/AgencyDetails";
import ReferralSource from "../containers/ReferralSource";
import ICD10 from "../containers/ICD10";
import RequestServices from "../containers/RequestServices";
import DocumentUpload from "../containers/DocumentUpload";
import Review from "./Review";
import { formatDate } from "../../../utils/DateTime";
import { DateFormats } from "../../../constants/Date";
import { physicianNameRegex } from "../../../constants/Regex";
import { ICD10CodeType } from "../../../constants/ICD10";
import { disciplinesRecord } from "../../../services/Temp/tempDisciplineRecord";
import { GetPatientInformationPayload, IngestPayload, MemberInfoData, Patient, PatientInformation, PatientInformationView } from "../../../models/Patient";
import { TabSessionStorageDispatchTypes } from "../../../constants/TabSessionStorage";
import { getFormattedCareType } from "../../../utils/PdfGeneration";
import { MessageType, ResponseMessages } from "../../../constants/ResponseMessage";
import { AuthorizationPayload, DocumentReviewList, DocumentReviewPayload, DocumentsUploadsResponse, DocumentUpload as DocumentUploadResponse, IsRetroDetails, PriorAuthSubmit } from "../../../models/Referral";
import { callDecisionEngineSuccessSwal, callDocumentErrorSwal, callFailedSwalVisible, callSuccessSwalVisible } from "../../../app/common/DocumentListStatus";
import { checkNurseToOpenSelected, flattenApiValidationErrors, getFilteredDiscipline, showMessageModal, TabsPanelSection } from "../../../app/common";
import SweetAlert from "../../../components/AuthFormComponents/SweetAlert";
import { MasterDisciplineActionDispatchTypes, MasterPayerActionDispatchTypes } from "../../../constants/Master";
import { getValidMessageType } from "../../../constants/User";
import { ApplicationTitles } from "../../../constants/HomePage";
import { redirectUri } from "../../../constants/Config";
import { UserPageTrack } from "../../../models/User";
import { getType } from "../../../constants/eligibility";
import { DocumentDownloadResponse } from "../../../models/api/Referral";

export interface PropsFromState {
  setCurrentTab: (id: number) => void;
  tabSessionStorage: TabSessionStorageResponse;
  currentTab: number;
  getValues: any;
  reset: any;
  setValue: any;
  control: any;
  clearErrors: any;
  formError: any;
  masterServiceProviderState: ListOptions[];
  masterSendCommunicationAuthTypeState: ListOptions[];
  loggedInUser: MyAccountModel;
  serviceProviderListWithDetails: ServiceProvider[];
  handleSubmit: () => any;
  trigger: any;
  masterReferralSourceState: ListOptions[];
  values: any;
  icd10RecordsFields: any[];
  icd10RecordsAppend: object;
  icd10RecordsRemove: (id: number) => void;
  watch: UseFormWatch<TabData>;
  formState: FormState<any>;
  errors: any;
  patientFromMbiState: Patient;
  memberInfoDataState: MemberInfoData;
  setReimbursementTypeId: (id: number) => void;
  reimbursementTypeId: number;
  masterCareTypeState: ListOptions[];
  disciplineListState: Discipline[];
  ingestProcessState: any;
  ingestProcessErrorState: any;
  priorAuthSubmitState: PriorAuthSubmit;
  priorAuthSubmitErrorState: any;
  documentUploadState: DocumentUploadResponse;
  documentUploadErrorState: any;
  patientInformationByIdState: PatientInformation;
  isRetroDetailsState: IsRetroDetails;
  documentDownloadData: DocumentDownloadResponse;
  documentReviewListData: DocumentReviewList;
  informationState: PatientInformationView;
}
export interface PropsFromDispatch {
  saveTabSessionStorage: (sessionData: TabData) => void;
  resetStates: (type: string) => void;
  handleSubmit: () => any;
  getMasterServiceProvider: (payload: AgencyListPayload) => void;
  getSendCommunicationAuthType: () => void;
  setFileUpload: (files: File[]) => void;
  ingestProcess: (formData: FormData) => void;
  fileUpload: File[];
  postPriorAuthSubmit: (payload: AuthorizationPayload) => void;
  uploadDocumentFile: (formData: FormData) => void;
  postUserPageTrack: (payload: UserPageTrack) => void;
  getDocumentByBlob: (blobId: number) => void;
  postDocumentReview: (payload: DocumentReviewPayload) => void;
  getPatientInformationById: (payload: GetPatientInformationPayload) => void;
}

type AllProps = PropsFromState & PropsFromDispatch;

const ReferralRequestTab: React.FC<AllProps> = ({
  setCurrentTab,
  currentTab,
  resetStates,
  formError,
  control,
  setValue,
  trigger,
  getValues,
  reset,
  values,
  icd10RecordsFields,
  icd10RecordsAppend,
  icd10RecordsRemove,
  clearErrors,
  watch,
  formState,
  handleSubmit,
  setFileUpload,
  fileUpload,
  tabSessionStorage,
  loggedInUser,
  patientFromMbiState,
  memberInfoDataState,
  setReimbursementTypeId,
  reimbursementTypeId,
  disciplineListState,
  masterCareTypeState,
  ingestProcess,
  ingestProcessState,
  ingestProcessErrorState,
  priorAuthSubmitState,
  priorAuthSubmitErrorState,
  documentUploadState,
  documentUploadErrorState,
  postPriorAuthSubmit,
  patientInformationByIdState,
  uploadDocumentFile,
  postUserPageTrack,
  masterSendCommunicationAuthTypeState,
  masterReferralSourceState,
  isRetroDetailsState,
  getDocumentByBlob,
  documentDownloadData,
  documentReviewListData,
  postDocumentReview,
  informationState,
  getPatientInformationById
}: AllProps) => {
  const [activeTab, setActiveTab] = useState(0);
  const [isNextStep, setIsNextStep] = useState<boolean>(false);
  const [isTabChange, setIsTabChange] = useState(false);
  const [backClick, setBackClick] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [hasFormError, setHasFormError] = useState(false);
  const [consolidatedErrors, setConsolidatedErrors] = useState<any>([]);
  const { email, firstName, lastName } = getValue(loggedInUser, "providerPortalUser", {});
  const [serviceAddressManualEntry, setServiceAddressManualEntry] =
    useState<boolean>(true);
  const [showAlert, setShowAlert] = useState<{
      type: "error" | "warning" | "success";
      title: string;
      message1: string;
      message2: string;
    } | null>(null);
  const [errorModal, setErrorModal] = useState<boolean>(false);
  const [modalFlag, setModalflag] = useState<boolean>(false);
  const [isConfirmNext, setIsConfirmNext] = useState<string | null>(null);
  const [decisionEngineModal, setDecisionEngineModal] = useState<boolean>(false);
  const [transactionDate, setTransactionDate] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [apiValidationErrors, setApiValidationErrors] = useState<string[]>([]);
  const { response: documentDownloadResponse } = documentDownloadData;
  useEffect(() => {
    if (currentTab === RequestTabCount) {
      setCurrentTab(activeTab);
    }
  }, [activeTab]);

  useEffect(() => {
    const formErrorLength = !isEmpty(get(formError, "response.sessionData", {}))
      ? Object.keys(get(formError, "response.sessionData", {})).length
      : 0;
    if (
      isTabChange &&
      formError &&
      !formError.loading &&
      formError.error &&
      Object.keys(formError.error).length === 0 &&
      formErrorLength >= 0
    ) {
      if (currentTab < RequestTabCount && currentTab !== RequestTabCount) {
        setCurrentTab(activeTab);
        setOpenAlert(false);
      }
      if (currentTab === RequestTabCount) {
        setCurrentTab(activeTab);
        setOpenAlert(false);
      }
      setIsTabChange(false);
    } else if (
      (isNextStep || backClick) &&
      formError &&
      !formError.loading &&
      formError.error &&
      Object.keys(formError.error).length === 0 &&
      formErrorLength >= 0
    ) {
      if (currentTab < RequestTabCount && currentTab !== RequestTabCount) {
        backClick && setCurrentTab(currentTab - 1);
        isNextStep && setCurrentTab(currentTab + 1);
      }
      if (currentTab === RequestTabCount) {
        setCurrentTab(activeTab);
      }
      setIsNextStep(false);
    }
  }, [formError]);

  const handleChange = async (
    _event: React.SyntheticEvent,
    newValue: number
  ) => {
    if (currentTab === RequestTabCount) {
      setActiveTab(newValue);
      setCurrentTab(newValue);
      return;
    }
  
    const isValid = await trigger();
    setIsConfirmNext("isTabChange");
    if (!isValid) {
      setHasFormError(true);
      const extractErrors = (errorsObj: any, parentKey = ""): any[] => {
        return Object.entries(errorsObj).flatMap(([key, value]) => {
          if (
            value &&
            typeof value === "object" &&
            ("message" in value || "type" in value)
          ) {
            return [{
              name: parentKey ? `${parentKey}.${key}` : key,
              message: (value as { message?: string }).message,
              type: (value as { type?: string }).type,
            }];
          } else if (value && typeof value === "object") {
            return extractErrors(value, parentKey ? `${parentKey}.${key}` : key);
          }
          return [];
        });
      };
      const rootErrors = extractErrors(formState.errors);

      if (rootErrors.length > 0) {
        setConsolidatedErrors(rootErrors);
      } else {
        setConsolidatedErrors(formState.errors);
      }
      return;
    }

    if (currentTab === Numbers.Four && isBcbsTn && (isRetroDetailsState?.isRetro === true)) {
      setModalflag(true);
      setActiveTab(newValue);
      return;
    }
    setOpenAlert(true);
    setActiveTab(newValue);
  };

  const isBcbsTn =
    getType({
      label: memberInfoDataState.healthPlan,
      value: memberInfoDataState.payerId,
    }) === Numbers.Four;

  const shouldOpenRetroModal = (isValid: boolean) => {
    if (
      currentTab === Numbers.Four &&
      isBcbsTn &&
      isRetroDetailsState?.isRetro === true &&
      isValid
    ) {
      setModalflag(true);
      return true;
    }
    return false;
  };

  const handleNextStep = async () => {
    const isValid = await trigger();
    setIsConfirmNext("isNext");
    if (shouldOpenRetroModal(isValid)) {
      return;
    } else {
      handleSubmit();
      setIsTabChange(false);
      setIsNextStep(true);
    }
  };

  const handleBackStep = async () => {
    const isValid = await trigger();
    setIsConfirmNext("isPrev");
    if (currentTab === RequestTabCount) {
      setCurrentTab(currentTab - 1);
    } else {
      if (shouldOpenRetroModal(isValid)) {
        return;
      } else {
        handleSubmit();
        setBackClick(true);
      }
    }
  };

  const handleBcbsModalConfirm = () => {
    if (isConfirmNext === "isNext") {
      handleSubmit();
      setIsTabChange(false);
      setIsNextStep(true);
    }
    if (isConfirmNext === "isPrev") {
      handleSubmit();
      setBackClick(true);
    }
    if (isConfirmNext === "isTabChange") {
      setOpenAlert(true);
    }
    setModalflag(false);
  };

  const handleSave = () => {
    handleSubmit();
    setIsTabChange(true);
    setOpenAlert(false);
  };

  const handleBackClick = () => {
    setOpenAlert(true);
    setBackClick(false);
    handleSubmit();
    if (currentTab !== 0) {
      setCurrentTab(currentTab - 1);
    }
  };
  const callPatientInformationById = (patientId: number) => {
    const payload = {
      id: patientId,
      type: 1,
    };
    getPatientInformationById(payload);
  };

    useEffect(() => {
      if (informationState && informationState.patientId > Numbers.ZERO && patientInformationByIdState
        && patientInformationByIdState.patientId === informationState.patientId && 
      patientInformationByIdState.patientEligibilityId !== informationState.patientEligibilityId) {
        callPatientInformationById(informationState.patientId);
      }
    }, [informationState]);

  const getPatientId = (): string => { 
      const patientId: number[] = [];
      if (!isEmpty(patientFromMbiState) && patientFromMbiState.patientDetails.length > 0) {
        patientFromMbiState.patientDetails.forEach(element => {
          patientId.push(element.patientId);
        });
        if (patientId.length > 1 && patientId[0] > 0) {
          return `MBI/Subscriber ID matching issue. Patient ${patientId.join(",")}`;
        }
        return "";
      }
      return "";
    }
  const handleSubmitReferral = () => {
    setConsolidatedErrors([]);
    const tabAndPatientData = tabSessionStorage.response;
    const pd = memberInfoDataState;
    const ad = tabAndPatientData.agencyDetails;
    const rs = tabAndPatientData.referralSource;
    const phyd = tabAndPatientData.physicianDetails;
    const refs = tabAndPatientData.referralServiceProvider;
    const reqs = tabAndPatientData.requestService;
    const pdPhys = tabAndPatientData.physicianDetails.primaryPhysician;
    const odPhys = tabAndPatientData.physicianDetails.orderingPhysician;
    const sad = rs.serviceAddressDetails;
    const transDate = new Date().toISOString();
    setTransactionDate(transDate);
    const icdCodes = getValue(
      tabAndPatientData,
      "icdCodesDetails.icdCodesInfoDto"
    ).map((item: any) => ({
      ...item,
      referralIcdCodeId: Numbers.ZERO,
    }));
      const serviceProviderUid = uuidv4();
      const getPatientDetailsValues = AuthorizationValuesForIngest({
        data: tabAndPatientData,
        icdCodes: icdCodes,
        memberInfoValues: pd,
        serviceProviderUid: serviceProviderUid,
        disciplinesRecord: disciplineListState,
        masterCareTypeState: masterCareTypeState,
        loggedInUser: loggedInUser,
        transDate: transDate,
      });
    if (memberInfoDataState && getValue(memberInfoDataState, "isIngest")) {
      const ingestPayload: IngestPayload = {
        EligibilityCheck: {
          LastName: pd.lastName,
          DateOfBirth: pd.dob,
          SubscriberId: pd.subscriberId,
          PayerId: pd.payerId,
          PayerName: pd.healthPlan,
        },
        MemberDetails: {
          MemberName: pd.memberName,
          SubscriberId: pd.subscriberId,
          Address: [
            pd.streetName1,
            pd.streetName2,
            pd.city,
            pd.patientState,
            pd.country,
            pd.zipCode,
          ]
            .filter(Boolean)
            .join(" "),
          PhoneNumber: pd.phoneNumber,
          DateOfBirth: pd.dob,
          MBI: pd.mbi,
          MemberPreferredLanguage: getLanguageLabel(
            pd.memberPreferredLanguage ?? ""
          ),
          Gender: pd.gender,
          HealthPlanName: pd.healthPlan,
        },
        AgencyDetails: {
          AgencyId: ad.serviceProviderId,
          RequestorEmail: ad.requesterEmail,
          AgencyName: ad.requesterName,
          AgencyLocationAddress: [
            ad.streetName1,
            ad.streetName2,
            ad.city,
            ad.requesterState,
            ad.county,
            ad.zipCode,
          ]
            .filter(Boolean)
            .join(" "),
          AgencyPhone: ad.requesterPhoneNo,
          Fax: ad.requesterFax,
          sendApprovedAuthTo: ad.sendApprovedAuthTo,
          secondaryEmailAddress: ad.secondaryEmailAddress,
        },
        FacilityInformation: {
          Name: rs.facilityName,
          NPI: rs.referralSourceNpi,
          Contact: rs.referralSourceEmail,
          Phone: rs.referralSourcePhoneNo,
          Fax: rs.referralSourceFax,
        },
        PrimaryCarePhysician: {
          Name: pdPhys?.physicianName?.replace(physicianNameRegex, "") ?? "",
          NPI: pdPhys?.physicianNpiId,
          Address: [
            pdPhys?.streetName1,
            pdPhys?.streetName2,
            pdPhys?.city,
            pdPhys?.physicianState,
            pdPhys?.county,
            pdPhys?.zipCode,
          ]
            .filter(Boolean)
            .join(" "),
          Phone: pdPhys?.phoneNo,
          Fax: pdPhys?.fax,
        },
        OrderingPhysician: {
          OrderingPrescriberName: odPhys.physicianName?.replace(
            physicianNameRegex,
            ""
          ),
          OrderingPrescriberNPI: odPhys.physicianNpiId,
          Address: [
            odPhys.streetName1,
            odPhys.streetName2,
            odPhys.city,
            odPhys.physicianState,
            odPhys.county,
            odPhys.zipCode,
          ]
            .filter(Boolean)
            .join(" "),
          Phone: odPhys.phoneNo,
          Fax: odPhys.fax,
        },
        ServiceAddress: [
          sad.streetName1,
          sad.streetName2,
          sad.city,
          sad.patientState,
          sad.county,
          sad.zipCode,
        ]
          .filter(Boolean)
          .join(" "),
        SocDate: formatDate(
          getValue(tabAndPatientData, "requestService.startOfCare"),
          DateFormats.MM_DD_YYYY,
          DateFormats.YYYY_MM_DD,
          true
        ),
        DateOfDC: "",
        PrimaryDiagnosis: tabAndPatientData.icdCodesDetails.icdCodesInfoDto
          .filter((item: any) => item.diagnosisTypeId === ICD10CodeType.PRIMARY)
          .map(
            (item: any) =>
              `${item.diagnosisCode} ${item.diagnosisCodeDescription}`
          )
          .join(", "),
        SecondaryDiagnosis: tabAndPatientData.icdCodesDetails.icdCodesInfoDto
          .filter(
            (item: any) => item.diagnosisTypeId === ICD10CodeType.SECONDARY
          )
          .map(
            (item: any) =>
              `${item.diagnosisCode} ${item.diagnosisCodeDescription}`
          )
          .join(", "),
        ClinicalGrouping: "",
        CareType: getFormattedCareType(tabAndPatientData, masterCareTypeState),
        SkilledType: getMatchingNames(
          getValue(tabAndPatientData, "requestService.discipline"),
          disciplinesRecord,
          1
        ).join(", "),
        Documents: fileUpload.map((file: File) => file.name),
        ReferralSource: (masterReferralSourceState && masterReferralSourceState.length > 0 && masterReferralSourceState.find((item: ListOptions) => item.value === Number(getValue(tabAndPatientData, "referralSource.facilityTypeId")))?.label) || "referralSourceHospital",
        UploadedByUserEmail: loggedInUser.providerPortalUser.email,
        SubmittedBy: loggedInUser.providerPortalUser.userName,
        SubmittedDate: currentDate(),
        Message: getPatientId(),
        GroupId: getValue(memberInfoDataState, "groupId", null),
      };
      submitIngestProcess(ingestPayload, getPatientDetailsValues);
    } else if (fileUpload.length > 0) {
      const date = currentDate();
      const payload = {
        requestId: getValue(tabAndPatientData, "requestId"),
        userCreated: email,
        noteComment: generateAgencyDetailsNote(
          getValue(tabAndPatientData, "agencyDetails.requesterName"),
          getValue(tabAndPatientData, "agencyDetails.requesterEmail"),
          getValue(tabAndPatientData, "agencyDetails.requesterFax"),
          getValue(tabAndPatientData, "agencyDetails.requesterPhoneNo"),
          getValue(tabAndPatientData, "agencyDetails.sendApprovedAuthTo"),
          getValue(tabAndPatientData, "agencyDetails.secondaryEmailAddress"),
          getFormattedCareType(tabAndPatientData, masterCareTypeState),
          getValue(tabAndPatientData, "requestService.isNurseToOpen"),
        ),
        referralIdCreated: date,
        authorizationDetail: {
          requestIntake: {
            referralDetail: {
              patientId: Number(patientInformationByIdState.patientId),
              urgencyId: 1,
              receivedMethodId: 6,
              receivedMethodName: "Provider Portal",
              isHomeBound: null,
              isSignedHealthOrder: "No",
              signedOrderDate: transDate,
              signedOrderType: "Written",
              orderedById: null,
              acceptedById: null,
              isCustodialCare: "No",
              isNonCoveredService: null,
              nonCoveredServices: null,
              healthProgramId: null,
              careProgramId: null,
              powerOfAttorney: null,
              urgencyStatus: null,
              orderedByName: null,
              acceptedByName: null,
              nonCoveredServiceNames: null,
              patientEligibilityId:
                patientInformationByIdState?.patientEligibilityId,
              fullNameCreated: pd.memberName,
              authorizationTypeId: 1,
              userCreated: Constants.SYSTEM_USER,
              authorizationNumber: null,
              authorizationTypeName: null,
              referralManagementSystemId: null,
              referralManagementSystemName: null,
              userSpecificReceivedDateTime: getValue(isRetroDetailsState, "effectiveEndDate") || dayjs().format("YYYY-MM-DDTHH:mm:ss"),
            },
            residentialAddress: {
              streetName1: pd.streetName1,
              streetName2: pd.streetName2,
              county: pd.county ?? "",
              country: pd.country,
              city: pd.city,
              patientState: pd.patientState,
              zipCode: pd.zipCode,
              latitude: 0,
              longitude: 0,
              addressTypeId: 1,
            },
            requester: ad,
            referralSource: {
              ...rs,
              facilityTypeId:
                rs &&
                rs.facilityTypeId !== undefined &&
                rs.facilityTypeId !== null
                  ? Number(rs.facilityTypeId)
                  : 0,
              dischargeDate: null,
              referralSourceEmail: rs.referralSourceEmail === "" ? null : rs.referralSourceEmail,
              serviceAddressDetails: {
                  ...getValues("referralSource.serviceAddressDetails"),
                  streetName1: rs.serviceAddressDetails.streetName1,
                  streetName2: rs.serviceAddressDetails.streetName2 || "",
                  city: rs.serviceAddressDetails.city || "",
                  patientState: rs.serviceAddressDetails.patientState || "",
                  zipCode: rs.serviceAddressDetails.zipCode || "",
                  country: rs.serviceAddressDetails.country || "",
                  county: rs.serviceAddressDetails.county || "",
                  addressTypeId: 2,
              },
            },
            serviceAddress: sad,
            isSameAsResidential: serviceAddressManualEntry,
            emergencyContact: null,
          },
          serviceRequestDetails: {
            userCreated: email,
            startOfCareDate: reqs.startOfCare,
            referralCareTypeDto: reqs.referralCareTypeDto,
            referralDisciplineDto: getFilteredDiscipline(
              reqs &&
              getValue(tabAndPatientData, "requestService.discipline").map(
                (item: number, index: number) => ({
                  disciplineId: checkNurseToOpenSelected(
                    item,
                    disciplineListState
                  )
                    ? Numbers.ONE
                    : item,
                  serviceNumber: index + 1,
                  acceptedVisits: Number(
                    getValue(
                      tabAndPatientData,
                      `requestService.referralDisciplineDto.${item}.acceptedVisits`
                    )
                  ),
                })
              )
            ),
            diseasesDto: null,
            psychologicalDiseasesDto: null,
            fullNameCreated: tabAndPatientData.userCreated,
            isNurseToOpen: getValue(
              tabAndPatientData,
              "requestService.isNurseToOpen"
            ),
            healthPlan: getValue(memberInfoDataState, "healthPlan"),
            userSpecificReceivedDateTime: getValue(isRetroDetailsState, "effectiveEndDate") || dayjs().format("YYYY-MM-DDTHH:mm:ss"),
          },
          icdCodesDetails: {
            ...tabAndPatientData.icdCodesDetails,
            icdCodesInfoDto: icdCodes,
          },
          referralPhysicianDetail: (phyd.primaryPhysician.physicianNpiId === null || phyd.primaryPhysician.physicianNpiId === "") ? {
            ...phyd, primaryPhysician: null
          } : phyd,
          referralServiceProvider: {
            ...refs,
            phone: refs?.phone ?? "",
            extension: refs?.extension ?? "",
            providerAddress: refs?.providerAddress ?? "",
            providerId: refs?.providerId ?? 0,
            plexisOfficeId: refs?.plexisOfficeId ?? 0,
          },
        },
      };

      if (
        !isEmpty(payload.authorizationDetail) &&
        priorAuthSubmitState?.referralId === 0
      ) {
        postPriorAuthSubmit(payload);
      }
    }
    
  };
  const submitIngestProcess = (
    submissionContent: any,
    getPatientDetailsValues: any
  ) => {
    const formData = new FormData();
    const fullName = memberInfoDataState?.memberName || "";

    formData.append("SubmissionSource", "2");
    formData.append("SubmissionContent", JSON.stringify(submissionContent));
    formData.append("UserId", email);
    fileUpload.forEach(file => formData.append("Files", file));
    formData.append("FullName", fullName);
    formData.append("AuthorizationType", "PriorAuth");
    formData.append("RequestId", getValue(
              tabSessionStorage,
              "response.requestId"
            ));
    formData.append("UserCreated", email);
    formData.append("PortalRequestDetail", JSON.stringify(getPatientDetailsValues));

    ingestProcess(formData);
    recordPageTrack();
    
  };
  const navigate = useNavigate();
  const handleCancel = () => {
    navigate(ApplicationRoute.MEMBER_INFO);
  };
  const recordPageTrack = () =>{
    postUserPageTrack(
      getUaserPageViewPayload(
        getValidMessageType(ApplicationTitles.CREATE_PRIOR_AUTH),
        getCurrnetPageFullPath(),
        redirectUri,
        fileUpload.map(file => file.name).join(",")
      )
    );
  }

  const resetAPIResponse = (type?: number) => {
    [
      MemberInfoDataActionDispatchTypes.MEMBER_INFO_DATA_RESET,
      EligibilityCheckActionDispatchTypes.ELIGIBILITY_CHECK_RESET,
      PatientFromMbiActionDispatchTypes.PATIENT_FROM_MBI_RESET,
      PatientInformationByIdActionDispatchTypes.PATIENT_INFORMATION_BY_ID_RESET,
      InformationActionDispatchTypes.INFORMATION_RESET,
      CreatePatientActionDispatchTypes.CREATE_PATIENT_RESET,
      TabSessionStorageDispatchTypes.SET_TAB_DATA_RESET,
      MasterPayerActionDispatchTypes.MASTER_PAYER_RESET,
      PostPriorAuthSubmitActionDispatchTypes.POST_PRIOR_AUTH_SUBMIT_RESET,
      ReferralDocumentFileDispatchTypes.REFERRAL_DOCUMENT_RESET,
      IcdCodeActionDispatchTypes.ICD_CODE_RESET,
      IngestProcessActionDispatchTypes.INGEST_PROCESS_RESET,
      MasterDisciplineActionDispatchTypes.MASTER_DISCIPLINE_INVOKE,
      IcdCodeActionDispatchTypes.ICD_CODE_RESET, Constants.ALL,
      SlotsDispatchTypes.SLOTS_RESET,
      DocumentReviewActionDispatchTypes.DOCUMENT_REVIEW_RESET,
      DocumentDownloadActionDispatchTypes.DOCUMENT_DOWNLOAD_RESET
    ].forEach((actionType) => resetStates(actionType));
    if (type === Numbers.ONE) {
       navigate(ApplicationRoute.MEMBER_INFO);
    }
   
  };

  /**Document Upload */
  useEffect(() => {
    if (ingestProcessState.length > 5) {
      sweetAlert();
    }
  }, [ingestProcessState])
  
  const sweetAlert = () => {
      setShowAlert({
        type: "success",
        title: "Success!",
        message1: priorAuthSubmitState.referralId > 0 ? ResponseMessages(MessageType.REFERRAL_SUCCESS) : ResponseMessages(MessageType.INGEST_SUCCESS),
        message2: priorAuthSubmitState.referralId > 0 ? `${priorAuthSubmitState?.authorizationNumber}` : ingestProcessState,
      });
  }
  useEffect(() => {
      if(priorAuthSubmitErrorState && priorAuthSubmitErrorState.length > 0) {
        setShowAlert({
          type: "error",
          title: "Error!",
          message1: priorAuthSubmitErrorState,
          message2: "",
        });
      } 
     }, [priorAuthSubmitErrorState]);
  
    useEffect(() => {
      if (ingestProcessState.length > 5) {
        sweetAlert();
      }
    }, [ingestProcessState])

    useEffect(() => {
      if (priorAuthSubmitState.referralId > 0) {
          sweetAlert();
          handleSaveFile(fileUpload);
        }
    }, [priorAuthSubmitState]);
  
  const handleSaveFile = (files: File[]) => {
      const formData = new FormData();
      formData.append("ReferralId", priorAuthSubmitState?.referralId.toString());
      formData.append("RequestId", priorAuthSubmitState?.requestId);
      formData.append("UserCreated", email);
      formData.append("DocumentData.ReferralBlobId", "0");
      formData.append("DocumentData.DocumentId", "10");
      formData.append("DocumentData.BlobId", "2");
      formData.append(
        "DocumentData.DateTimeReceived",
        formatDate(currentDate(true), DateFormats.MM_DD_YYYY)
      );
      formData.append("DocumentData.DocumentSourceId", "4");
      formData.append(
        "DocumentData.UserFullName",
        `${firstName} ${lastName} `
      );
      formData.append("ReferralDocumentDetail.Type", "1");
      formData.append("DocumentData.ReferralDocument", "");
      files.forEach((file: File, index: number) => {
        const updatedFile = new File(
        [file],
        appendTimestampToFilename(file.name, getFormattedDateTime(index + 1)),
        { type: file.type }
      );
        formData.append("referralDocumentList", updatedFile);
      });
      formData.append("ReferralDocumentDetail.DocumentationDate", formatDate(currentDate(true), DateFormats.MM_DD_YYYY));
      formData.append("ReferralDocumentDetail.ContainsSupportedDoc", "true");
      formData.append("ReferralDocumentDetail.ServiceRequestId", priorAuthSubmitState?.serviceRequestId.toString());
      formData.append("DocumentData.IsPortalDocument", "true");
      formData.append("ReceivedReferralDateTime", transactionDate);
      uploadDocumentFile(formData);
      postUserPageTrack(
        getUaserPageViewPayload(
          getValidMessageType(ApplicationTitles.CREATE_PRIOR_AUTH),
          getCurrnetPageFullPath(),
          redirectUri,
          files.map((file: File) => file.name).join(",")
        )
      );
    };

  const getDocumentDataFromReviewDocList = () => {
    const blobId = getValue(documentUploadState, "dseResponse.blobId");
    const documentData = getValue(
      documentReviewListData,
      "blobDocumentList",
    ).filter((doc: any) => doc.blobId === blobId);
    return documentData;
  };
  
   /**Swal Visible */
  useEffect(() => { 
    if (documentReviewListData && getValue(documentReviewListData, "blobDocumentList.length") > 0) {
      sweetAlert();
      const documentData = getDocumentDataFromReviewDocList();
      setTimeout(() => {
        const alertDetails = {
          type: "success",
          title: "Success!",
          message1:
            priorAuthSubmitState.referralId > Numbers.ZERO
              ? "Your authorization request has been approved."
              : "",
          message2:
            priorAuthSubmitState.referralId > Numbers.ZERO
              ? `${priorAuthSubmitState?.authorizationNumber}`
              : "",
          message3:
            ResponseMessages(MessageType.DECISION_ENGINE_MESSAGE1),
          message4:
            ResponseMessages(MessageType.DECISION_ENGINE_MESSAGE2),
        };
        callDecisionEngineSuccessSwal(
          documentData,
          alertDetails,
          setShowAlert,
          () => resetAPIResponse(Numbers.ONE),
          reset,
          onDocumentClick,
        );
      }, 500);
      
    }
  },[documentReviewListData])

  useEffect(() => {
    const documentData = getDocumentDataFromReviewDocList();
    if (documentDownloadResponse) {
      const blob = new Blob([documentDownloadResponse.blob], {
        type: documentDownloadResponse.headers["content-type"],
      }); 
      saveAs(
        blob,
        documentData[0]?.originalDocumentName || "Auth notification.pdf",
        { autoBom: false },
      );
    }
  }, [documentDownloadResponse]);

  useEffect(() => {
    if (documentUploadState && getValue(documentUploadState, "dseResponse.blobId") > Numbers.ZERO && getValue(documentUploadState, "dseResponse.isDseQualified") === true) {
      setShowAlert(null)
      resetStates(DocumentReviewActionDispatchTypes.DOCUMENT_REVIEW_RESET);
      const Payload = createDocumentReviewPayload(getValue(priorAuthSubmitState, "referralId"));
      Payload.referralId > Numbers.ZERO && postDocumentReview(Payload);
    } else if (
      documentUploadState?.documentUploads &&
      (documentUploadState?.documentUploads.length > Numbers.ZERO)
    ) {
      setDecisionEngineModal(false);
      sweetAlert();
      setTimeout(() => {
         let failedCount = Numbers.ZERO;
      documentUploadState?.documentUploads.forEach((document: DocumentsUploadsResponse) => {
        if (document.status === "Failed") {
          failedCount++;
        }
      });
        const alertDetails = {
        type: "success",
        title: "Success!",
        message1: priorAuthSubmitState.referralId > Numbers.ZERO ? ResponseMessages(MessageType.REFERRAL_SUCCESS) : ResponseMessages(MessageType.INGEST_SUCCESS),
        message2: priorAuthSubmitState.referralId > Numbers.ZERO ? `${priorAuthSubmitState?.authorizationNumber}` : ingestProcessState,
      }
      failedCount > Numbers.ZERO && callFailedSwalVisible(documentUploadState, alertDetails, setShowAlert, () => resetAPIResponse(Numbers.ONE), reset);
      failedCount === Numbers.ZERO && callSuccessSwalVisible(documentUploadState, alertDetails, setShowAlert, () => resetAPIResponse(Numbers.ONE), reset);
      }, 1000);
    } else {
      resetStates(PostPriorAuthSubmitActionDispatchTypes.POST_PRIOR_AUTH_SUBMIT_RESET); 
    }
  }, [documentUploadState])
  
    useEffect(() => { 
      if (documentUploadErrorState && documentUploadErrorState.length > 0 && 
        documentUploadErrorState === ResponseMessages(MessageType.DOCUMENT_NOT_UPLOADED)
      ) {
        callDocumentErrorSwal(documentUploadState, showAlert, setShowAlert, () => resetAPIResponse(Numbers.ONE), reset)
      }
    },[documentUploadErrorState])

      useEffect(() => {
        if (
          (ingestProcessErrorState && ingestProcessErrorState.length > Numbers.ZERO)
        ) {
          setErrorModal(true);
        }
        return () => { 
          resetStates(IngestProcessActionDispatchTypes.INGEST_PROCESS_RESET)
        }
      }, [ingestProcessErrorState]);

  useEffect(() => {
    setApiValidationErrors([]);
    const validationErrors = flattenApiValidationErrors(priorAuthSubmitErrorState);
    if (typeof priorAuthSubmitErrorState === "object" && priorAuthSubmitErrorState !== null && validationErrors.length > 0) {
      setApiValidationErrors(validationErrors);
      setErrorModal(true);
      setErrorMessage(ResponseMessages(MessageType.PRIOR_AUTH_NOT_CREATED));
      return;
    }
    if (priorAuthSubmitErrorState && typeof priorAuthSubmitErrorState === "string" && priorAuthSubmitErrorState.length > 0) {
      setErrorMessage(ResponseMessages(MessageType.PRIOR_AUTH_NOT_CREATED));
      setErrorModal(true);
    }
  }, [priorAuthSubmitErrorState]);

  const onDocumentClick = (blobId: number) => {
    getDocumentByBlob(blobId);
  };
  
  return (
    <DetailBox>
      <Box sx={width100PCT}>
        <Grid container sx={ReferralGrid}>
          <Grid size={{ xs: 12 }}>
            <Box>
              <Box>
                <PatientHeaderTabs
                  value={currentTab}
                  onChange={handleChange}
                  aria-label="Patient Header Tabs"
                >
                  {PriorAuthHeaderLabel.map((data, index) => (
                    <PatientHeaderTab
                      key={nanoid()}
                      label={data.label}
                      {...a11yProps(index)}
                    />
                  ))}
                </PatientHeaderTabs>
              </Box>
              <TabsPanelSection value={currentTab} index={0}>
                <AgencyDetails
                  control={control}
                  setValue={setValue}
                  trigger={trigger}
                  getValues={getValues}
                  setReimbursementTypeId={setReimbursementTypeId}
                  reset={reset}
                  clearErrors={clearErrors}
                />
              </TabsPanelSection>
              <TabsPanelSection value={currentTab} index={1}>
                <ReferralSource
                  getValues={getValues}
                  control={control}
                  setValue={setValue}
                  reset={reset}
                  setServiceAddressManualEntry={setServiceAddressManualEntry}
                  serviceAddressManualEntry={serviceAddressManualEntry}
                />
              </TabsPanelSection>
              <TabsPanelSection value={currentTab} index={2}>
                <OrderingPhysician
                  control={control}
                  getValues={getValues}
                  setValue={setValue}
                  reset={reset}
                  watch={watch}
                  clearErrors={clearErrors}
                  tabSessionStorage={tabSessionStorage}
                />
              </TabsPanelSection>
              <TabsPanelSection value={currentTab} index={3}>
                <ICD10
                  icdvalues={values}
                  control={control}
                  setValue={setValue}
                  getValues={getValues}
                  fields={icd10RecordsFields}
                  append={icd10RecordsAppend}
                  remove={icd10RecordsRemove}
                  reset={reset}
                  clearErrors={clearErrors}
                  watch={watch}
                  formState={formState}
                />
              </TabsPanelSection>
              <TabsPanelSection value={currentTab} index={4}>
                <RequestServices
                  control={control}
                  setValue={setValue}
                  reimbursementTypeId={reimbursementTypeId}
                  getValues={getValues}
                  reset={reset}
                  modalOpen={modalFlag}
                  setModalOpen={setModalflag}
                  onModalConfirm={handleBcbsModalConfirm}
                  tabSessionStorage={tabSessionStorage}
                />
              </TabsPanelSection>
              <TabsPanelSection value={currentTab} index={5}>
                <DocumentUpload
                  setValue={setValue}
                  control={control}
                  reset={reset}
                  getValues={getValues}
                  setFileUpload={setFileUpload}
                  fileUpload={fileUpload}
                />
              </TabsPanelSection>
              <TabsPanelSection value={currentTab} index={6}>
                <Review
                  tabSessionStorage={tabSessionStorage}
                  files={fileUpload}
                  masterCareTypeState={masterCareTypeState}
                  disciplineListState={disciplineListState}
                  masterSendCommunicationAuthTypeState={
                    masterSendCommunicationAuthTypeState
                  }
                />
              </TabsPanelSection>
            </Box>
          </Grid>
        </Grid>
        <Grid container sx={flexAlignCentre}>
          <Grid size={{ xs: 6 }} sx={CancelButtonGrid}>
            <Button
              variant="outlined"
              sx={ButtonMinWidth_Outlined}
              onClick={() => {
                handleCancel();
                resetAPIResponse();
              }}
            >
              CANCEL
            </Button>
          </Grid>
          <Grid size={{ xs: 6 }} sx={NextButtonGrid}>
            {currentTab !== RequestTabCount ? (
              <>
                <Button
                  variant="outlined"
                  onClick={handleBackStep}
                  disabled={currentTab === 0}
                  sx={ButtonMinWidth_Outlined}
                >
                  PREVIOUS
                </Button>
                <Button
                  variant="contained"
                  sx={ButtonMinWidth}
                  onClick={handleNextStep}
                >
                  NEXT
                </Button>
              </>
            ) : (
              <Button
                onClick={() => handleSubmitReferral()}
                sx={ButtonMinWidth}
                variant="contained"
                disabled={notVisitedTabs(tabSessionStorage).length > 0}
              >
                Create Authorization Request
              </Button>
            )}
          </Grid>
        </Grid>
        <AlertDialog
          alertMessage={SaveDetailsAlertMessage}
          openAlert={openAlert}
          setOpenAlert={setOpenAlert}
          handleSubmit={handleSave}
          back={backClick}
          handleBackClick={handleBackClick}
        />
        {hasFormError && (
          <ErrorDialog
            hasFormError={hasFormError}
            setHasFormError={setHasFormError}
            formError={consolidatedErrors}
          />
        )}
        {showAlert &&
          !decisionEngineModal &&
          (getValue(priorAuthSubmitState, "referralId") > 0 ||
            (ingestProcessState && ingestProcessState.length > 5) ||
            (priorAuthSubmitErrorState &&
              priorAuthSubmitErrorState.length > 0)) && (
            <SweetAlert
              message1={showAlert.message1}
              message2={showAlert.message2}
              onClose={() => {
                resetStates(
                  PostPriorAuthSubmitActionDispatchTypes.POST_PRIOR_AUTH_SUBMIT_RESET,
                );
                if (
                  priorAuthSubmitErrorState === null &&
                  ingestProcessErrorState === null
                ) {
                  handleCancel();
                  reset();
                  resetAPIResponse();
                }
                setShowAlert(null);
              }}
            />
          )}
        {errorModal &&
          showMessageModal(
            errorModal,
            setErrorModal,
            errorMessage || ResponseMessages(MessageType.INGEST_PROCESS_FAILED),
            undefined,
            false,
            apiValidationErrors,
          )}
        <ConfirmationDialog
          openConfirmation={openConfirmation}
          setOpenConfirmation={setOpenConfirmation}
          confirmationMessageTitle={confirmationMessage}
        />
      </Box>
    </DetailBox>
  );
};

export default ReferralRequestTab;
